import { motion } from "framer-motion"
import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import Navbar from "@/components/Navbar"
import Footer from "@/components/Footer"
import ExpertisesHero from "@/components/ExpertisesHero"
import WerkplaatsContactSection from "@/components/WerkplaatsContactSection"
import ReviewsCarousel from "@/components/ReviewsCarousel"
import { useNavigate } from "react-router-dom"
import { useQuery } from 'react-query'
import { getExpertises } from '@/api/expertiseService'
import { Heading } from "@/components/ui/heading"


export function ExpertisesPage() {
  const navigate = useNavigate()
  const { data: expertises = [] } = useQuery('expertises', getExpertises);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <ExpertisesHero />

      {/* Expertise Grid — domogo style */}
      <section className="bg-[#f2f2f0] py-20 md:py-28 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-8 md:px-12 lg:px-16">
          {/* Header */}
          <h2
            className="text-black text-3xl md:text-4xl lg:text-[2.75rem] font-medium tracking-[0.08em] leading-[1.1] mb-12 md:mb-16"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            VERMADO EXPERTISES
          </h2>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {expertises.map((expertise, index) => (
              <motion.div
                key={expertise.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/expertises/${expertise.id}`);
                }}
                className="cursor-pointer group"
              >
                <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden mb-4">
                  <img
                    src={expertise.imageUrl}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    alt={expertise.title}
                  />
                </div>
                <h3
                  className="text-black text-sm font-semibold tracking-[0.08em] uppercase text-center"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                  {expertise.title}
                </h3>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <WerkplaatsContactSection />

      <ReviewsCarousel />

      <Footer />
    </div>
  )
} 